import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import Heading2 from "components/Heading/Heading2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { commonAxiosPostRequest } from "utils/request";
import { getKeyByLang } from "utils/util";

export type LegalDocumentContentKey = "privacyPolicyContent" | "userAgreementContent";

export interface PageLegalDocumentProps {
	className?: string;
	contentKey: LegalDocumentContentKey;
	titleI18nKey: string;
}

const userAgreementServiceDescriptions: Record<string, string> = {
	"zh-HK": "本服務提供線上食品及飲品選購、訂單處理、付款及送貨相關服務。",
	"zh-CN": "本服务提供在线食品及饮品选购、订单处理、付款及配送相关服务。",
	en: "This service provides online food and beverage shopping, order processing, payment, and delivery services.",
};

const replaceUserAgreementPlaceholder = (content: string, language: string) => {
	const description = userAgreementServiceDescriptions[language] || userAgreementServiceDescriptions["zh-HK"];
	return content.replace(
		/本服務提供\[(?:簡要描述您的服務內容|简要描述您的服务内容|briefly describe your service)\]。?/gi,
		description,
	);
};

const PageLegalDocument: FC<PageLegalDocumentProps> = ({
	className = "",
	contentKey,
	titleI18nKey,
}) => {
	const { t } = useTranslation();
	const { language } = i18n;
	const [configInfo, setConfigInfo] = useState<Record<string, string>>({});

	const handleQueryConfigInfo = async () => {
		const [, response] = await commonAxiosPostRequest<{ config: Record<string, string> }, {}>(
			"/universal_mall/api/app/common/config",
			{},
		);
		setConfigInfo(response?.config || {});
	};

	useEffect(() => {
		handleQueryConfigInfo();
	}, []);

	const rawContent =
		configInfo?.[getKeyByLang(language, contentKey)] || configInfo?.[contentKey] || "";
	const content = contentKey === "userAgreementContent"
		? replaceUserAgreementPlaceholder(rawContent, language)
		: rawContent;

	return (
		<div className={`nc-PageLegalDocument overflow-hidden relative ${className}`}>
			<BgGlassmorphism />
			<div className="container py-8 lg:py-16 space-y-8 lg:space-y-12">
				<Heading2 heading={t(titleI18nKey)} />
				<div dangerouslySetInnerHTML={{ __html: content }} />
			</div>
		</div>
	);
};

export default PageLegalDocument;
